import React from "react";

const Calendar: React.FC = () => {
  return <h1>Calendar Page</h1>;
};

export default Calendar;
